module.exports = __webpack_public_path__ + "bdfbea66d6b3d778ed0d66b939b5ec45.svg";